import { createFileRoute } from "@tanstack/react-router";
import { DefaultCatchBoundary } from "~/components/default-catch-boundary";
import {
  normalizeAppSettingsSearch,
  type AppSettingsSearch,
} from "~/features/settings/settings-search";

export const Route = createFileRoute("/_app")({
  errorComponent: DefaultCatchBoundary,
  loader: ({ context, location }) => {
    void import("~/features/app-shell/app-shell-route").then(
      ({ preloadAppShellSidebarData }) => {
        void preloadAppShellSidebarData({
          context,
          pathname: location.pathname,
        });
      },
    );
  },
  validateSearch: (raw): AppSettingsSearch =>
    normalizeAppSettingsSearch(raw as Record<string, unknown>),
});
